module.exports = __webpack_public_path__ + "static/media/OH.ddecf5a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/OH.svg
// module id = 249
// module chunks = 0